import React, {useEffect, useState} from "react";
import {Col, Container, Row} from "react-bootstrap";
import ScaleLoader from "react-spinners/ScaleLoader";
import {useHistory, withRouter} from "react-router-dom";
import {getActivePadelboxEditions} from "../../../services/leagues";
import {useTranslation} from "react-i18next";

// React Components
import Header from "../../../components/Header";
import BulletHeader from "../../../components/BulletHeader/BulletHeader";
import Card from "../../../components/Card/Card";

const override = `
    display: block;
    text-align: center;
    margin-top: 10%;
    `;

const LeagueEditionSelection = (props) => {
   const [leagueEditions, setLeagueEditions] = useState(null);
   const [loading, setLoading] = useState(true);
   const history = useHistory();
   const {t} = useTranslation();

   useEffect(() => {
      (async () => {
         let leagueEditions = await getActivePadelboxEditions();

         setLeagueEditions(leagueEditions);
         setLoading(false);
      })()
   }, []);

   return <div className={"LeagueEditionSelection"}>
      <Header headerBarTitle={t("other_leagues_page.header")}/>

      <Container className={"desktop"}>
         <Row>
            <Col className={"pb-3"} xs={12} sm={12}>
               <BulletHeader text={t("other_leagues_page.padelbox_leagues")}/>
               <p>{t("other_leagues_page.select_edition")}</p>
            </Col>
         </Row>

         <ScaleLoader
            css={override}
            sizeUnit={"px"}
            size={30}
            color={'#AFFF55'}
            loading={loading}
         />

         <Row>
            {!loading && leagueEditions.map(leagueEdition => {
               return <Card
                  key={leagueEdition.id}
                  text={leagueEdition.name}
                  onClick={() => history.push(`/other-leagues/${leagueEdition.id}/leagues`, {leagues: leagueEdition.leagues})}
               />
            })}
         </Row>
      </Container>
   </div>
}

export default withRouter(LeagueEditionSelection);
